// dependencies
import { Map, List } from "immutable";
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { changePageUI as updateUI } from "Actions/ui";

// selectors
import { getUI } from "Selectors/ui";
import { getFileList, getInputValue } from "./selectors";

/**
 * Fetch (or refetch) the data
 */
export const fetchPageData = () => async (dispatch, getState) => {
	// dispatch(updateUI([], currentUI));
};

const parseFile = async (file) =>
	new Promise((resolve, reject) => {
		const temporaryFileReader = new FileReader();

		temporaryFileReader.onerror = () => {
			temporaryFileReader.abort();
			reject(new DOMException("Problem parsing input file."));
		};

		temporaryFileReader.onload = () => {
			resolve(temporaryFileReader.result);
		};

		temporaryFileReader.readAsDataURL(file);
	});

/**
 * Uploads a file to S3.
 * @param {File} file - file to upload
 */
export const uploadScreenshot = (file) => async (dispatch, getState) => {
	const fileReader = await parseFile(file);

	// upload files
	const request = await dispatch(GenerateProcess("UploadScreenshot", { payload: { base64String: fileReader } }));
	const { fileName } = request.response;

	// parse state
	const state = getState();
	const fileList = getFileList(state);

	// update upload list
	dispatch(updateUI(["fileList"], fileList.concat(List([fileName]))));
};

export const removeScreenshot = (fileID) => async (dispatch, getState) => {
	const state = getState();
	const fileList = getFileList(state);

	dispatch(
		updateUI(
			["fileList"],
			fileList.filter((file) => file !== fileID)
		)
	);
};

export const changeInput = (name, value) => async (dispatch) => {
	dispatch(updateUI(["inputs", name], value));
};

export const sendBugReport = () => async (dispatch, getState) => {
	const state = getState();

	const bugReport = Map({
		screenshots: getFileList(state),
		whatIDid: getInputValue(state, "whatIDid"),
		requestID: getInputValue(state, "requestID"),
		whatHappened: getInputValue(state, "whatHappened"),
		whatIExpected: getInputValue(state, "whatIExpected"),
	});

	const request = await dispatch(GenerateProcess("CreateBugReport", { payload: bugReport.toJS() }));
	console.log(request);
};

/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	// set the initial UI
	const initialUI = ui;
	dispatch(updateUI([], initialUI));

	// fetch page data
	dispatch(fetchPageData());
};
